export type FieldType = 'link'

const fieldTypes: Record<string, FieldType> = {
  PDB_NA_P_Link_Vollmacht_Netzbetreiber: 'link',
  PDB_NA_P_Link_NAV_Liegenschaft: 'link',
  PDB_NA_P_Link_Baurechtliche_Genehmigung_LIS: 'link',
  PDB_Wartung_Link_IBN_Protokoll_Ordner: 'link',
  PDB_Wartung_Link_Protokoll_Schluesseluebergabe: 'link',
  PDB_Wartung_Link_Betrieb_Uebergabedokument_Checkliste: 'link',
}

export function getFieldType(fieldName: string): FieldType | undefined {
  return fieldTypes[fieldName]
}

export function normalizeLinkHref(value: string): string | undefined {
  const trimmedValue = value.trim()
  if (trimmedValue.length === 0) {
    return undefined
  }

  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmedValue)) {
    return trimmedValue
  }

  return `https://${trimmedValue}`
}
